'use strict';

module.exports = {
  template: require('./salary-round.html'),
  controller: require('./salary-round.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-round/index.js
 ** module id = 224
 ** module chunks = 0
 **/